module.exports = __webpack_public_path__ + "img/d1.6958ab8b.png";